export default __webpack_public_path__ + "/dist/images/6989508.png";